module.exports = __webpack_public_path__ + "static/media/floral-pattern.6734d89a.svg";